import React from 'react';

type Brand = 'all' | 'mars-men' | 'hollow-socks' | 'easy-street';

interface BrandFilterProps {
  selectedBrand: Brand;
  onBrandChange: (brand: Brand) => void;
}

const BrandFilter: React.FC<BrandFilterProps> = ({ selectedBrand, onBrandChange }) => {
  const brands = [
    { id: 'all', name: 'All Brands', color: '#2ECC71' },
    { id: 'mars-men', name: 'Mars Men', color: '#FF6B35' },
    { id: 'hollow-socks', name: 'Hollow Socks', color: '#4A90E2' },
    { id: 'easy-street', name: 'Easy Street', color: '#2ECC71' },
  ];

  return (
    <div className="brand-filter">
      {brands.map((brand) => (
        <button
          key={brand.id}
          className={`brand-button ${selectedBrand === brand.id ? 'active' : ''}`}
          onClick={() => onBrandChange(brand.id as Brand)}
          style={{
            '--brand-color': brand.color,
          } as React.CSSProperties}
        >
          <span className="brand-indicator"></span>
          {brand.name}
        </button>
      ))}
    </div>
  );
};

export default BrandFilter;